import React, { useState, useEffect, useContext } from 'react';
import Button from '../../../NecttosComp/Button/Button';
import { getAxiosTokenInstance } from '../../../utils/axiosInstance';
import { Course, UserRole } from '../../types/lms.types';
import { getMockCourses, getDashboardStats } from '../../services/lmsDataService';
import { NecttosContext } from '../../../context/NecttosContext';
import DashboardAssignment from './dashboardAssignment';
import DashboardAnnouncements from './dashboardAnnouncements';


interface LMSDashboardProps {
  userRole: UserRole;
  userName: string;
  collegeData: any;
  onCourseSelect: (course: any) => void;
  onViewAssignment: (assignment: any, source?: string) => void;
}

const LMSDashboard: React.FC<LMSDashboardProps> = ({
  userRole,
  userName,
  collegeData,
  onCourseSelect,
  onViewAssignment
}) => {
  const [courses, setCourses] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('courses');
  const [user, setUser] = useState<{name: string, collegeName: string}>()
  
  const { userId } = useContext(NecttosContext)
  useEffect(() => {
  const loadUser = async () => {
    const instance = await getAxiosTokenInstance();
    try {
      const response = await instance.get('/college/lms/all/getUserWithCollege', {
        params: { userId }
      });

      if (response?.data) {
        setUser(response.data.data);  // ✅ use response.data instead of response
      }
    } catch (err) {
      console.log('error occurred');
    }
  };

  loadUser();
}, []);

  useEffect(() => {
  const loadData = async () => {
    const instance = await getAxiosTokenInstance();
    setLoading(true);

    if (userRole === 'teacher') {
      try {
        const resp = await instance.get(
          '/college/lms/all/getTeachersEnrolledCourses?teacherId=NT-1B59DFD0ADCA-477D-87AC-1AFE714F599F&collegeId=COL-D4F1E2B6FCE5-457C-AB5D-3D0F80462CF0'
        );
        if (resp?.data) {
          setCourses(resp.data.data);
        }
      } catch (error) {
        console.error('Error loading courses:', error);
      } finally {
        setLoading(false);
      }
    } else if(userRole === 'student') {
      try{
        const resp = await instance.get(
          `/college/lms/all/getStudentEnrolledCourses?studentId=NST-24CC30EF1B6F-4CA8-A416-0C79605B15DB&collegeId=COL-D4F1E2B6FCE5-457C-AB5D-3D0F80462CF0&classId=CLASS-34A55DABB5D9-4053-85DB-873CCDA74A39`
        )
        if(resp.data.success){
          console.log(resp.data.data);
          setCourses(resp.data.data)
        }

      }catch(err){

      }
      setLoading(false); // Optional: handle non-teacher role
    }else if(userRole == 'admin') {
      try{
        const resp = await instance.get(
          `college/lms/all/getSchoolEnrolledCourses?collegeId=COL-D4F1E2B6FCE5-457C-AB5D-3D0F80462CF0`
        )
        if(resp.data.success){
          setCourses(resp.data.data)
        }

      }catch(err){

      }
    }
  };

  loadData();
}, [userRole]);


console.log("courses =>", courses)

  const stats = getDashboardStats(userRole);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
      {/* Welcome Section */}
      <div className="mb-8">
        <h2 className="text-2xl font-bold text-gray-900 mb-2">
          Welcome back, {user?.name}!
        </h2>
        <p className="text-gray-600">
          Here's your learning dashboard for {user?.collegeName || 'your institution'}.
        </p>
      </div>

      {/* Stats Cards
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        {stats.map((stat, index) => (
          <div key={index} className="bg-white rounded-lg shadow p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-600">{stat.title}</p>
                <p className="text-2xl font-bold text-gray-900">{stat.value}</p>
              </div>
              <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                <span className="text-blue-600 text-xl">{stat.icon}</span>
              </div>
            </div>
          </div>
        ))}
      </div> */}

      {/* Navigation Tabs */}
      <div className="border-b border-gray-200 mb-6">
        <nav className="-mb-px flex space-x-8">
          {['courses', 'assignments', 'announcements', 'analytics'].map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`py-2 px-1 border-b-2 font-medium text-sm capitalize ${
                activeTab === tab
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              {tab}
            </button>
          ))}
        </nav>
      </div>

      {/* Courses Tab */}
      {activeTab === 'courses' && (
        <div>
          <div className="flex justify-between items-center mb-6">
            <h3 className="text-lg font-semibold text-gray-900">
              {userRole === 'student' ? 'Enrolled Courses' : 
               userRole === 'teacher' ? 'My Courses' : 'All Courses'}
            </h3>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {courses.map((course) => (
              <div key={course.subjectId} className="bg-white rounded-lg shadow hover:shadow-md transition-shadow p-6">
                <div className="flex items-start justify-between mb-4">
                  <h4 className="text-lg font-semibold text-gray-900 flex-1">
                    {course.name}
                  </h4>
                  {/* {course.isLive && (
                    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-red-800">
                      <span className="w-2 h-2 bg-red-400 rounded-full mr-1 animate-pulse"></span>
                      Live
                    </span>
                  )} */}
                </div>
                
                <p className="text-sm text-gray-600 mb-4">
  Instructor: {course.teachers.join(', ')}
</p>

                
                <div className="space-y-2 mb-4">
                  <div className="flex justify-between text-sm text-gray-600">
                    <span>Students</span>
                    <span className="font-medium">{course.count}</span>
                  </div>
                  
                  {userRole === 'student' && course.progress !== undefined && (
                    <div className="space-y-1">
                      <div className="flex justify-between text-sm text-gray-600">
                        <span>Progress</span>
                        <span className="font-medium">70%</span>
                      </div>
                      <div className="w-full bg-gray-200 rounded-full h-2">
                        <div 
                          className="bg-blue-600 h-2 rounded-full transition-all duration-300"
                          // style={{ width: `${course.progress}%` }}
                          style={{ width: '70%' }}
                        />
                      </div>
                    </div>
                  )}
                  
                  <div className="flex justify-between text-sm text-gray-600">
                    {/* <span>{course.assignments} assignments</span>
                    <span>{course.announcements} announcements</span> */}
                     <span>{course.assignments} assignments</span>
                    <span>{course.announcements} announcements</span>
                  </div>
                </div>

                <div className="w-full">
                  <Button
                    type="view"
                    onClick={() => onCourseSelect(course)}
                  >
                    Open Course
                  </Button>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Other tabs content */}
      {/* {activeTab !== 'courses' && (
        <div className="bg-white rounded-lg shadow p-8 text-center">
          <h3 className="text-lg font-semibold text-gray-900 mb-2 capitalize">
            {activeTab}
          </h3>
          <p className="text-gray-600">
            {activeTab} management will be shown here.
          </p>
        </div>
      )} */}

      {activeTab =='assignments' && (
        <DashboardAssignment
        courses={courses}
        userRole={userRole}
        onViewAssignment={onViewAssignment}
        />
      )}
      {activeTab == 'announcements' && (
        <DashboardAnnouncements
        courses={courses}
        userRole={userRole}
        />
      )}
     
    </div>
  );
};

export default LMSDashboard;
